import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigOptions } from '../models/common-data-types';

@Injectable({
  providedIn: 'root'
})
export class SelfcareConfigService {

  constructor(private http: HttpClient) { }

  getVehicleConfigOptions(): Observable<ConfigOptions> {
    return this.http.get<ConfigOptions>(`/selfcare/vehicle-properties`);
  }

  getVehicleMetadata(): Observable<any> {
    return this.http.get<any[]>(`/metadata/vehicles/makes`);
  }

  getVehicleModels(makeId: string): Observable<any> {
    return this.http.get<any[]>(`/metadata/vehicles/makes/${makeId}/models`);
  }
}
